module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_uneedcom_m2.d1d4136da60d1290ada2e143963e5332.png";